import Inputs from "components/inputs";

const RecommendItem = ({ answers, itemClassName, question, priority }) => {
  return (
    <div
      className={`mt-10 px-4 py-5 shadow-lg bg-white rounded-lg ${itemClassName}`}
    >
      <h2 className="caption-12px-medium text-gray--2">
        پاسخ خود را انتخاب کنید.
      </h2>
      <h1 className="body-14px-regular text-gray-4 mt-2 mb-8">
        {priority ? `${priority}. ` : ""}
        {question}
      </h1>
      <Inputs
        type="radio"
        label={""}
        name="answer"
        autocomplete="off"
        required
        options={answers?.map((item) => ({
          title: item.value,
          key: item.id,
        }))}
      />
    </div>
  );
};

export default RecommendItem;
